var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRegressioninline = function SvgRegressioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.008,
    cy: 22,
    r: 22,
    fill: "#7D64FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#regression_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.008 13.803v-1.679a.6.6 0 0 1 .933-.499l4.318 2.88a.6.6 0 0 1 0 .998l-4.318 2.878a.6.6 0 0 1-.933-.499v-1.679h-8a.8.8 0 0 0-.8.8v10a.8.8 0 0 0 .8.8h3a1.2 1.2 0 0 1 0 2.4h-3a3.2 3.2 0 0 1-3.2-3.2v-10a3.2 3.2 0 0 1 3.2-3.2h8Zm4 12.321v1.68h8a.8.8 0 0 0 .8-.8v-10a.8.8 0 0 0-.8-.8h-3a1.2 1.2 0 1 1 0-2.4h3a3.2 3.2 0 0 1 3.2 3.2v10a3.2 3.2 0 0 1-3.2 3.2h-8v1.678a.6.6 0 0 1-.933.5l-4.318-2.88a.6.6 0 0 1 0-.998l4.318-2.879a.6.6 0 0 1 .933.5Z",
    fill: "url(#regression_inline_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "regression_inline_svg__b",
    x1: 22.012,
    y1: 1.677,
    x2: 22.012,
    y2: 35.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "regression_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.008 10)",
    d: "M0 0h28v24H0z"
  })))));
};
export default SvgRegressioninline;